<template>
  <div>
    <div class="relative w-full header">
      <div class="header-title"></div>
      <div class="title">工程项目</div>
    </div>
    <div class="bg-white" style="min-height: calc(100vh - 520px)">
      <div class="max-w-screen-xl pt-8 m-auto overflow-hidden">
        <div class="py-2">
          <div class="w-full overflow-hidden">
            <div class="float-left pr-6 text-gray-400">保函分类:</div>
            <div
              :class="[
                'pr-6 cursor-pointer float-left',
                queryParam.eq.temp_category_id == '' ? 'text-blue-500' : 'text-black',
              ]"
              @click="categoryChange('')"
            >
              全部
            </div>
            <div
              :class="[
                'pr-6 cursor-pointer float-left',
                queryParam.eq.temp_category_id == item.id ? 'text-blue-500' : 'text-black',
              ]"
              @click="categoryChange(item.id)"
              v-for="(item, index) in TempCategorys"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="py-2 overflow-hidden">
          <div class="float-left pr-4 leading-8 text-gray-400">开标日期:</div>
          <div :class="['pr-4 float-left']">
            <a-range-picker
              v-model="queryParam.time.bidder_timef"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
            />
          </div>
        </div>
        <div class="py-2 overflow-hidden">
          <div class="float-left pr-4 leading-8 text-gray-400">名称搜索:</div>
          <div :class="['pr-4 float-left']">
            <a-input
              placeholder="请输入您要搜索的项目名称"
              v-model="queryParam.like.name"
              style="width: 266px"
            />
          </div>
        </div>
        <div class="py-2 pl-20 text-left">
          <a-button @click="getProject" type="primary" class="mr-3">搜索</a-button>
          <a-button @click="reset">重置</a-button>
        </div>
        <a-divider style="margin-bottom: 0 !important" />
        <div class="pb-6">
          <a-list
            :loading="loading"
            item-layout="horizontal"
            :data-source="projectlist"
            :pagination="pagination"
          >
            <template slot="renderItem" slot-scope="item">
              <a-list-item>
                <div class="w-full pb-4">
                  <div>
                    <div class="justify-between flow-root w-full pb-2">
                      <div class="float-left text-xl text-black truncate">
                        {{ item.name }}
                      </div>
                      <div class="float-right">
                        <a-button
                          v-if="
                            !item.is_bidder ||
                            permission(['contract', 'apply/:id?'], 'bind_company')
                          "
                          type="primary"
                          @click="gotoTemp(item)"
                          >申请保函</a-button
                        >
                        <a-button v-else type="primary" disabled>已投保</a-button>
                      </div>
                      <div style="float: none; clear: both"></div>
                    </div>
                  </div>
                  <div>
                    <div v-if="item.record_no" class="flex w-full">
                      <div class="text-gray-400">备案登记号:</div>
                      <div>{{ item.record_no }}</div>
                    </div>
                    <div class="flow-root w-full">
                      <div class="float-left w-1/3">
                        <div class="float-left pr-4 text-gray-400">业主:</div>
                        <div>{{ item.proprietor }}</div>
                      </div>
                      <div class="float-left w-1/3">
                        <div class="float-left pr-4 text-gray-400"> 担保金额: </div>
                        <div>{{ item.money }}</div>
                      </div>
                      <div class="float-left w-1/3">
                        <div class="float-left pr-4 text-gray-400"> 开标时间: </div>
                        <div>{{ item.bidder_time }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </a-list-item>
            </template>
          </a-list>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { projects_byindex } from '@/api/project';
  import { temp_categorys } from '@/api/temp';
  import permission from '@/utils/permission';
  export default {
    data() {
      return {
        queryParam: { eq: { temp_category_id: '', ggb: ""}, like: {}, time: {} },
        TempCategorys: [],
        projectlist: [],
        pagination: {
          onChange: (page) => {
            // console.log(page);
            this.pagination.current = page;
            this.getProject();
          },
        },
        loading: true,
      };
    },
    mounted() {
      this.getTempCategorys();
    },
    activated() {
      if (this.$route.query.temp_category_id) {
        this.categoryChange(this.$route.query.temp_category_id);
      } else {
        this.getProject();
      }
    },
    methods: {
      permission,
      async getTempCategorys() {
        this.TempCategorys =
          (
            await temp_categorys({
              qp: JSON.stringify({ eq: { review: 1 } }),
              orderby: 'a.sort desc',
            })
          ).data || [];
      },
      async getProject() {
        this.loading = true;
        let res = await projects_byindex({
          current: this.pagination.current,
          qp: JSON.stringify(this.queryParam),
        });
        console.log(res);
        this.projectlist = res.data || [];
        this.pagination.total = res.total;
        this.loading = false;
      },
      categoryChange(category_id) {
        this.queryParam.eq = { temp_category_id: category_id };
        this.pagination.current = 1;
        this.getProject();
      },
      reset() {
        this.queryParam = {
          eq: { temp_category_id: '' , ggb: ""},
          time: { bidder_timef: [] },
          like: { name: '' },
        };
        this.pagination.current = 1;
        this.getProject();
      },
      gotoTemp(record) {
        this.$router.push(`/admin/contract_apply?project_id=${record.id}`);
      },
    },
  };
</script>
<style lang="less" scoped>
  .header {
    height: 400px;
    background-image: url(https://zjsxrz.oss-cn-hangzhou.aliyuncs.com/static/default/2022-08-13/da6c4d02-9977-4b92-b5a8-0193f44f7d76.jpg);
    background-clip: padding-box;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position: center center;
    background-blend-mode: normal;
    .header-title {
      width: 100%;
      height: 400px;
      background-image: linear-gradient(#3b82f6, #3b82f6);
      opacity: 0.4;
    }
  }
  .title {
    padding: 150px;
    line-height: 100px;
    font-size: 40px;
    color: #ffffff;
    position: absolute;
    text-align: center;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
  }
  .title:before {
    content: '';
    position: absolute;
    width: 1rem;
    height: 4px;
    top: 198px;
    left: 41%;
    background-color: #ffffff;
  }
  .title:after {
    content: '';
    position: absolute;
    width: 1rem;
    height: 4px;
    top: 198px;
    right: 41%;
    background-color: #ffffff;
  }
</style>
